import { Link } from "react-router-dom";

const values = [
    {
        number: "01",
        title: "Quality First",
        description:
            "We carefully select products that combine quality, functionality, and value.",
    },
    {
        number: "02",
        title: "Simple Shopping",
        description:
            "Shopping should be simple. We keep the experience clean, fast, and easy to understand.",
    },
    {
        number: "03",
        title: "Customer Focused",
        description:
            "Everything we do starts with our customers and the experience we want to create for them.",
    },
    {
        number: "04",
        title: "Always Improving",
        description:
            "We continuously improve our products, service, and technology to create a better experience.",
    },
];

const About = () => {
    return (
        <main className="relative overflow-hidden px-6 py-32 md:px-12 lg:px-20">

            <div className="mx-auto max-w-[1600px]">

                <section className="flex min-h-[70vh] items-center">
                    <div className="max-w-6xl">
                        <h1 className="text-5xl font-black leading-[0.9] tracking-tighter text-gray-900 dark:text-white sm:text-6xl md:text-8xl lg:text-[110px]">
                            We make
                            <br />
                            <span className="text-indigo-600">
                                shopping
                            </span>{" "}
                            simple.
                        </h1>

                        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-gray-500 dark:text-gray-400 md:text-xl">
                            We believe great products should be easy to discover,
                            simple to buy, and enjoyable to use. Our goal is to
                            create a better everyday shopping experience.
                        </p>

                    </div>
                </section>


                {/* Story */}
                <section className="border-t border-gray-200 py-32 dark:border-gray-800">

                    <div className="grid gap-16 lg:grid-cols-2">

                        <div>
                            <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-400">
                                Our Story
                            </p>

                            <h2 className="mt-6 text-4xl font-black tracking-tighter text-gray-900 dark:text-white md:text-6xl">
                                Less noise.
                                <br />
                                More{" "}
                                <span className="text-indigo-600">
                                    value.
                                </span>
                            </h2>
                        </div>

                        <div className="space-y-6 text-lg leading-relaxed text-gray-500 dark:text-gray-400">
                            <p>
                                We started with a simple idea: online shopping
                                doesn't need to feel complicated.
                            </p>

                            <p>
                                Instead of overwhelming customers with endless
                                choices and unnecessary distractions, we focus
                                on finding products that are useful, reliable,
                                and worth having.
                            </p>

                            <p>
                                From discovering a product to adding it to your
                                cart, every part of the experience is designed
                                to be clear, fast, and enjoyable.
                            </p>
                        </div>

                    </div>

                </section>


                <section className="border-t border-gray-200 py-32 dark:border-gray-800">

                    <div className="mb-20">
                        <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-400">
                            What We Believe
                        </p>

                        <h2 className="mt-6 max-w-4xl text-4xl font-black tracking-tighter text-gray-900 dark:text-white md:text-7xl">
                            Built around the things
                            <span className="text-indigo-600">
                                {" "}that matter.
                            </span>
                        </h2>
                    </div>


                    <div className="grid md:grid-cols-2 grid-cols-1 gap-6 border-gray-200 dark:border-gray-800">
                    {values.map((value) => (
                    <div key={value.number} className="group block rounded-3xl border border-gray-200 bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl dark:border-gray-800 dark:bg-gray-900">

                        <div className="md:flex block justify-between">
                            <h5 className="md:text-2xl text-xl font-bold capitalize tracking-tight text-gray-900 dark:text-white">
                                {value.title}
                            </h5>
                            <p className="md:text-md text-sm font-normal text-gray-900 dark:text-white">
                                {value.description}
                            </p>
                        </div>

                        <div className="mt-8 h-1 w-8 rounded-full bg-indigo-600 transition-all duration-500 group-hover:w-16" />
                    </div>
                    ))}

                    </div>

                </section>


                <section className="rounded-[2rem] bg-gray-900 px-8 py-16 text-white md:px-16 md:py-20">

                    <div className="grid gap-12 md:grid-cols-3">

                        <div>
                            <p className="text-5xl font-black tracking-tighter md:text-7xl">
                                10K+
                            </p>

                            <p className="mt-3 text-gray-400">
                                Happy Customers
                            </p>
                        </div>

                        <div>
                            <p className="text-5xl font-black tracking-tighter md:text-7xl">
                                500+
                            </p>

                            <p className="mt-3 text-gray-400">
                                Products
                            </p>
                        </div>

                        <div>
                            <p className="text-5xl font-black tracking-tighter md:text-7xl">
                                24/7
                            </p>

                            <p className="mt-3 text-gray-400">
                                Customer Support
                            </p>
                        </div>

                    </div>

                </section>


                <section className="py-32 text-center">

                    

                    <h2 className="mx-auto mt-6 max-w-4xl text-5xl font-black tracking-tighter text-gray-900 dark:text-white md:text-7xl">
                        Ready to
                        <span className="text-indigo-600">
                            {" "}Explore?
                        </span>
                    </h2>

                    <Link
                        to="/products"
                        className="mt-10 inline-flex items-center gap-3 rounded-full bg-gray-900 px-7 py-4 text-lg font-semibold text-white transition-all duration-300 hover:scale-105 hover:bg-indigo-600 dark:bg-white dark:text-black"
                    >
                        Explore Products
                    </Link>

                </section>

            </div>

        </main>
    );
};

export default About;